export const roomiBlue = {
  50: '#f0f4ff',
  100: '#d9e3ff',
  200: '#c0d0ff',
  300: '#a6bdfe',
  400: '#93affe',
  500: '#80a1fe',
  600: '#7899fe',
  700: '#6d8ffe',
  800: '#6385fe',
  900: '#5074fd',
  A100: '#ffffff',
  A200: '#ffffff',
  A400: '#f4f6ff',
  A700: '#dae2ff',
  contrastText: '#fff'
};

export const roomiGold = { // TODO: which color is this? Maybe gold is not the best name?
  50: '#fdf9f4',
  100: '#faf0e3',
  200: '#f7e7d1',
  300: '#f4ddbf',
  400: '#f1d5b1',
  500: '#efcea3',
  600: '#edc99b',
  700: '#ebc291',
  800: '#e8bc88',
  900: '#e4b077',
  A100: '#ffffff',
  A200: '#ffffff',
  A400: '#fffefd',
  A700: '#fff2e4',
  contrastText: '#fff'
};

export const roomiRed = {
  50: '#fbeeea',
  100: '#f5d4ca',
  200: '#efb7a7',
  300: '#e99a84',
  400: '#e48469',
  500: '#df6e4f',
  600: '#db6648',
  700: '#d75b3f',
  800: '#d25136',
  900: '#ca3f26',
  A100: '#ffffff',
  A200: '#ffd9d4',
  A400: '#ffada1',
  A700: '#ff9787'
};
